import { Check } from "lucide-react";

export default function QuestionInput({ q, value, onChange }) {
  if (q.type === "text" || q.type === "email") {
    return (
      <input
        data-testid={`q-input-${q.id}`}
        type={q.type}
        placeholder={q.placeholder || ""}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-14 px-5 text-lg bg-white border-2 border-slate-200 rounded-xl focus:border-[#1E3A8A] focus:outline-none transition-colors"
        autoFocus
      />
    );
  }
  if (q.type === "textarea") {
    return (
      <textarea
        data-testid={`q-input-${q.id}`}
        placeholder={q.placeholder || ""}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={4}
        className="w-full p-5 text-base bg-white border-2 border-slate-200 rounded-xl focus:border-[#1E3A8A] focus:outline-none resize-none transition-colors"
        autoFocus
      />
    );
  }
  if (q.type === "radio") {
    return (
      <div className="space-y-3" role="radiogroup">
        {q.options.map((opt) => {
          const selected = value === opt;
          return (
            <button
              key={opt}
              data-testid={`q-opt-${q.id}-${opt}`}
              type="button"
              onClick={() => onChange(opt)}
              className={`w-full text-left p-4 rounded-xl border-2 flex items-center gap-3 transition-all ${
                selected ? "border-[#1E3A8A] bg-[#1E3A8A]/5" : "border-slate-200 hover:border-slate-300"
              }`}
            >
              <span className={`w-5 h-5 rounded-full border-2 grid place-items-center ${selected ? "border-[#1E3A8A]" : "border-slate-300"}`}>
                {selected && <span className="w-2.5 h-2.5 rounded-full bg-[#1E3A8A]" />}
              </span>
              <span className="text-base text-slate-900">{opt}</span>
            </button>
          );
        })}
      </div>
    );
  }
  if (q.type === "checkbox") {
    const arr = Array.isArray(value) ? value : [];
    const toggle = (opt) => {
      const next = arr.includes(opt) ? arr.filter((x) => x !== opt) : [...arr, opt];
      onChange(next);
    };
    return (
      <div className="space-y-3">
        {q.options.map((opt) => {
          const checked = arr.includes(opt);
          return (
            <button
              key={opt}
              data-testid={`q-opt-${q.id}-${opt}`}
              type="button"
              onClick={() => toggle(opt)}
              className={`w-full text-left p-4 rounded-xl border-2 flex items-center gap-3 transition-all ${
                checked ? "border-[#1E3A8A] bg-[#1E3A8A]/5" : "border-slate-200 hover:border-slate-300"
              }`}
            >
              <span className={`w-5 h-5 rounded-md border-2 grid place-items-center transition-colors ${checked ? "border-[#1E3A8A] bg-[#1E3A8A]" : "border-slate-300"}`}>
                {checked && <Check className="w-3.5 h-3.5 text-white" />}
              </span>
              <span className="text-base text-slate-900">{opt}</span>
            </button>
          );
        })}
      </div>
    );
  }
  return null;
}
